module.exports = __webpack_public_path__ + "img/announcement.8d7a107f.svg";